export const pathToFileName = inputPath => {
    if (inputPath) {
        const file = inputPath.split('/').pop();
        let filename = file.split('.').slice(0, -1).join('.').replace(/_/g, ' ').replace(/^(product-|application-)/, '');
        return filename;
    }

    return "Document";
};

export const makePdfUrl = path => {
    const pdf = path.split('/').pop();
    const href = `https://www.gelest.com/themencode-pdf-viewer/?file=https://www.gelest.com/wp-content/uploads/` + pdf;
    return href;
};

export const markdownToHtml = (text, applyProductLink = true) => {
    if (text) {
        // First replace image markdown syntax: ![alt](url)
        const markdownImageRegex = /!\[([^\]]*)\]\(([^\)]+)\)/g;
        // Then replace link markdown syntax: [text](url)
        const markdownLinkRegex = /\[([^\[]+)\]\(([^\)]+)\)/g;
        // Product code patterns - uses word boundaries to avoid matching inside base64 strings
        const productCodeRegex = /\b([A-Z]{2}\d-[A-Z]{2}\d{2}(?:\.[A-Z]?\d+)?[A-Z]?|[A-Z]{2,3}\d{4}(?:\.[A-Z]?\d+)?[A-Z]?|[A-Z]{2,3}-[A-Z]{0,2}\d{2,3}|[A-Z]{2,3}-[A-Z]{2,3}|[A-Z]{2}\d[A-Z]{3}|[A-Z]{2}\d-[A-Z]{2,3}|(?<!\.)\d{4}(?:\.[A-Z]?\d+)?)\b/g;
        
        // Convert product codes to markdown links first (won't match if already in markdown link or URL)
        let result = applyProductLink ? text.replace(productCodeRegex, (match, code, offset) => {
            // Check if this match is inside a markdown link [...](...)
            const beforeMatch = text.substring(0, offset);
            const afterMatch = text.substring(offset);
            const inLinkText = /\[[^\]]*$/.test(beforeMatch) && /^[^\[]*\]\([^\)]+\)/.test(afterMatch);
            const inLinkUrl = /\[[^\]]+\]\([^\)]*$/.test(beforeMatch) && /^[^\)]*\)/.test(afterMatch);
            
            // Check if inside a URL (has :// or / before it within reasonable distance, and continues with URL-like chars)
            const inUrl = /(https?:\/\/[^\s]*|\/[^\s]*)$/.test(beforeMatch) && /^[^\s]*/.test(afterMatch);
            
            // Check if inside an HTML tag
            const inHtmlTag = /<[^>]*$/.test(beforeMatch) && /^[^>]*>/.test(afterMatch);
            
            if (inLinkText || inLinkUrl || inUrl || inHtmlTag) {
                return match; // Don't convert if inside a markdown link, URL, or HTML tag
            }
            return `[${code}](https://www.gelest.com/product/${code}/)`;
        }) : text;
        
        // Then convert markdown to HTML
        result = result
            .replace(markdownImageRegex, '<img src="$2" alt="$1" class="message-image" style="max-width: 300px; border-radius: 8px; margin: 10px 0;" />')
            .replace(markdownLinkRegex, '<a href="$2" target="_blank">$1</a>')
            .replace(/(?<!<\/?[^>]+>)\n/g, '<br />');

        return result;
    }
    
    return text;
};